import { Box, Button, Container, Stack, Typography } from "@mui/material";

import { signupCopy } from "../config";

interface SignupProps {
  onSneakPreview: () => void;
}

export function Signup({ onSneakPreview }: SignupProps): JSX.Element {
  return (
    <Box component="main" sx={{ py: { xs: 4, sm: 6 } }}>
      <Container maxWidth="md">
        <Stack component="section" spacing={2.25}>
          <Typography variant="h3" component="h1">
            {signupCopy.heading}
          </Typography>
          <Stack component="ul" spacing={1.5} sx={{ m: 0, pl: 3 }}>
            <Typography component="li">
              <Box component="strong">{signupCopy.matchLottery.title}:</Box>{" "}
              {signupCopy.matchLottery.body}
            </Typography>
            <Typography component="li">
              {signupCopy.matchLotteryPrizeDistribution}
            </Typography>
            <Typography component="li">
              {signupCopy.matchLotteryEntryFee}
            </Typography>
            <Typography component="li">{signupCopy.consolationPrize}</Typography>
            <Typography component="li">
              <Box component="strong">
                {signupCopy.winnerTeamLottery.title}:
              </Box>{" "}
              {signupCopy.winnerTeamLottery.body}
            </Typography>
            <Typography component="li">
              {signupCopy.winnerTeamLotteryEntryFee}
            </Typography>
            <Typography component="li">{signupCopy.registration}</Typography>
            <Typography component="li">{signupCopy.seedLinkText}</Typography>
            <Typography component="li">
              {signupCopy.resultsAvailability}{" "}
              <Button
                onClick={onSneakPreview}
                size="small"
                sx={{ ml: 0.5, textTransform: "none" }}
                variant="contained"
              >
                {signupCopy.sneakPreviewLabel}
              </Button>
            </Typography>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
